var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoad),expression:"showLoad"}],staticClass:"calculator__loader"},[_vm._m(0)])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calculator__loader_inner"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }